/**
 * Steuert das ausklappbare Newsletter-Popup unten links (Mode Weiss,
 * 2026-09-06): erscheint nach 30 Sekunden auf Startseite/Kollektionsseiten
 * (siehe snippets/newsletter-popup.liquid), lässt sich schließen und merkt
 * sich das für einige Zeit in localStorage - kein Tracking, keine
 * Drittanbieter-Skripte.
 *
 * Update 2026-09-06: Zweistufig - zunächst nur der Mini-Teaser (Rabatt-
 * Anreiz), erst per Klick klappt das Formular aus (Klasse
 * "newsletter-popup--expanded", Höhen-Animation übernimmt reines CSS, siehe
 * assets/newsletter-popup.css).
 *
 * Update 2026-09-06 (2): Vor dem Absenden werden die angehakten
 * "Interessensgebiet"-Checkboxen (Damen Mode/Bodywear/Herren Mode) als
 * zusätzliche Tags an das versteckte contact[tags]-Feld angehängt - so
 * lässt sich in Shopify Admin später nach Interesse segmentieren, ohne dass
 * dafür ein eigenes Metafeld o. Ä. nötig wäre.
 */
(function () {
  var STORAGE_KEY = 'mode-weiss-newsletter-popup-dismissed-until';
  var DISMISS_DAYS = 30;
  var SUBSCRIBED_DAYS = 365;
  var SHOW_DELAY_MS = 30000;
  var EXPAND_TRANSITION_MS = 350;
  var BASE_TAG = 'newsletter';

  function readDismissedUntil() {
    try {
      var value = window.localStorage.getItem(STORAGE_KEY);
      return value ? parseInt(value, 10) : 0;
    } catch (e) {
      return 0;
    }
  }

  function writeDismissedUntil(days) {
    try {
      var until = Date.now() + days * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(STORAGE_KEY, String(until));
    } catch (e) {
      /* localStorage nicht verfügbar (z. B. privater Modus) - kein Problem,
         das Popup erscheint dann bei jedem Besuch erneut, aber die Seite
         funktioniert unverändert weiter. */
    }
  }

  function isDismissed() {
    return Date.now() < readDismissedUntil();
  }

  var NewsletterPopup = /** @class */ (function () {
    function init(el) {
      var card = el.querySelector('.newsletter-popup__card');
      var closeButton = el.querySelector('.newsletter-popup__close');
      var miniButton = el.querySelector('.newsletter-popup__mini');
      var form = el.querySelector('#NewsletterPopupForm');
      var tagsField = el.querySelector('#NewsletterPopupTags');
      var interestCheckboxes = el.querySelectorAll('.newsletter-popup__interest-checkbox');
      var emailField = el.querySelector('#NewsletterPopupEmail');
      var firstNameField = el.querySelector('#NewsletterPopupFirstName');
      var forceOpen = el.getAttribute('data-force-open') === 'true';
      var hasSuccessMessage = !!el.querySelector('.newsletter-form__message--success');
      var timer = null;

      function show() {
        el.hidden = false;
        // Einen Frame warten, damit der Uebergang (opacity/transform) beim
        // Entfernen von [hidden] tatsaechlich animiert und nicht sofort
        // "hart" erscheint.
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            el.classList.add('newsletter-popup--visible');
          });
        });
      }

      function hide(dismissDays) {
        el.classList.remove('newsletter-popup--visible');
        window.setTimeout(function () {
          el.hidden = true;
        }, 350);
        writeDismissedUntil(dismissDays || DISMISS_DAYS);
      }

      function expand(focusFirstField) {
        el.classList.add('newsletter-popup--expanded');
        if (miniButton) miniButton.setAttribute('aria-expanded', 'true');
        if (focusFirstField && firstNameField) {
          window.setTimeout(function () {
            firstNameField.focus();
          }, EXPAND_TRANSITION_MS);
        }
      }

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          hide(DISMISS_DAYS);
        });
      }

      if (miniButton) {
        miniButton.addEventListener('click', function () {
          expand(true);
        });
      }

      // Angehakte Interessensgebiete als zusaetzliche Tags an das
      // versteckte contact[tags]-Feld anhaengen, bevor das native Formular
      // tatsaechlich abgeschickt wird (kein preventDefault - laeuft danach
      // ganz normal als Shopify-Formular weiter).
      if (form && tagsField) {
        form.addEventListener('submit', function () {
          var tags = [BASE_TAG];
          interestCheckboxes.forEach(function (checkbox) {
            if (checkbox.checked && checkbox.value) {
              tags.push(checkbox.value);
            }
          });
          tagsField.value = tags.join(', ');
        });
      }

      if (forceOpen) {
        // Seite wurde gerade per Formular-Submit neu geladen (Erfolg oder
        // Fehler) - Popup sofort direkt mit ausgeklapptem Formular zeigen,
        // nicht erst den Mini-Teaser und nicht erst nach 30 Sekunden warten.
        show();
        expand(false);
        if (hasSuccessMessage) {
          writeDismissedUntil(SUBSCRIBED_DAYS);
        }
        return;
      }

      if (isDismissed()) {
        return;
      }

      timer = window.setTimeout(function () {
        if (!isDismissed()) {
          show();
        }
      }, SHOW_DELAY_MS);

      // Aufraeumen, falls das Popup-Element aus irgendeinem Grund vor Ablauf
      // der 30 Sekunden aus dem DOM entfernt wird (z. B. durch spaetere
      // Theme-Anpassungen mit dynamischem Nachladen).
      window.addEventListener(
        'pagehide',
        function () {
          if (timer) window.clearTimeout(timer);
        },
        { once: true }
      );
    }

    return {
      init: init,
    };
  })();

  document.addEventListener('DOMContentLoaded', function () {
    var el = document.getElementById('NewsletterPopup');
    if (el) NewsletterPopup.init(el);
  });
})();
